import { render, staticRenderFns } from "./EditExpertTagModal.vue?vue&type=template&id=f1940754&scoped=true"
import script from "./EditExpertTagModal.vue?vue&type=script&lang=js"
export * from "./EditExpertTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1940754",
  null
  
)

export default component.exports